export const API_SERVER_BASE_URL =
  import.meta.env.VITE_API_SERVER_BASE_URL ?? "https://api.underconstruction.fun/travelJournal/v1";

export function getApiUrl(path: string): string {
  return `${API_SERVER_BASE_URL.replace(/\/$/, "")}/${path.replace(/^\//, "")}`;
}
